import React from 'react';
import './Project.css';

function Projects ()
{
  return (
    <section className="tc-projects-style2">
      <div className="container">
        <div className="tabs-links mt-10">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-proj1-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-proj1"
                type="button"
              >
                Home Interior
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-proj2-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-proj2"
                type="button"
              >
                Corporate Interior
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-proj3-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-proj3"
                type="button"
              >
                Commercial Restaurant
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-proj4-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-proj4"
                type="button"
              >
                Architecture
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="tab-content" id="pills-tabContent">
        {/* Home Interior */ }
        <div
          className="tab-pane fade show active"
          id="pills-proj1"
          role="tabpanel"
          aria-labelledby="pills-proj1-tab"
        >
          <div className="container mt-50 mb-50">
            <div className="jangoz-row jangoz-row-3">
              <div className="jangoz-img-card">
                <a href="/project/jangoz">
                  <img
                    src="/assets/jangoz/jangoz1.JPG"
                    alt="Jangoz 1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Jangoz</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/manoj-bhavan">
                  <img
                    src="/assets/manoj bhavan/manojbhavan1.jpg"
                    alt="Manoj Bhavan 1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Manoj Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/padmam">
                  <img
                    src="/assets/Padmam/HRP00005.jpg"
                    alt="padmam1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Padmam</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/rwd-club-house">
                  <img
                    src="/assets/rwd club house/rwdclubhouse1.JPG"
                    alt="rwd club house1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">RWD Club House</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/surya-bhavan">
                  <img
                    src="/assets/surya bhavan/suryabhavan1.jpeg"
                    alt="Surya Bhavan 1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Surya Bhavan</span>
                  </div>
                </a>
              </div>

              <div className="jangoz-img-card">
                <a href="/project/vip-residential">
                  <img
                    src="/assets/VIP residential/VIP residental1.jpeg"
                    alt="VIP Residential 1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">VIP Residential</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card jangoz-last-centered">
                <a href="/project/dbs-workspace">
                  <img
                    src="/assets/DBS workspace/Dbs workspace3.jpeg"
                    alt="DBS Workspace 1"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">DBS Workspace</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>


        {/* Corporate Interior */ }
        <div
          className="tab-pane fade"
          id="pills-proj2"
          role="tabpanel"
          aria-labelledby="pills-proj2-tab"
        >
          <div className="container mt-50 mb-50">
            <div className="jangoz-row jangoz-row-3">
              <div className="jangoz-img-card">
                <a href="/project/jangoz">
                  <img
                    src="/assets/jangoz/jangoz8.JPG"
                    alt="Jangoz 2"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Jangoz</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/padmam">
                  <img
                    src="/assets/Padmam/HRP00030.jpg"
                    alt="Padmam2"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Padmam</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/rwd-club-house">
                  <img
                    src="/assets/rwd club house/rwdclubhouse2.JPG"
                    alt="rwdclubhouse2"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">RWD Club House</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/surya-bhavan">
                  <img
                    src="/assets/surya bhavan/suryabhavan7.jpeg"
                    alt="Surya Bhavan"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Surya Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/dbs-workspace">
                  <img
                    src="/assets/DBS workspace/Dbs workspace7.jpeg"
                    alt="DBS Workspace"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">DBS Workspace</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/vip-residential">
                  <img
                    src="/assets/VIP residential/VIP residental7.jpeg"
                    alt="VIP Residential"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">VIP Residential</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Commercial Restaurant */ }
        <div
          className="tab-pane fade"
          id="pills-proj3"
          role="tabpanel"
          aria-labelledby="pills-proj3-tab"
        >
          <div className="container mt-50 mb-50">
            <div className="jangoz-row jangoz-row-3">
              <div className="jangoz-img-card">
                <a href="/project/jangoz">
                  <img
                    src="/assets/jangoz/jangoz3.JPG"
                    alt="jangoz3"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Jangoz</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/manoj-bhavan">
                  <img
                    src="/assets/manoj bhavan/manojbhavan2.jpg"
                    alt="manojbhavan2"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Manoj Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/padmam">
                  <img
                    src="/assets/Padmam/HRP09683.jpg"
                    alt="Padmam 3"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Padmam</span>
                  </div>
                </a>
              </div>

              <div className="jangoz-img-card jangoz-last-centered">
                <a href="/project/rwd-club-house">
                  <img
                    src="/assets/rwd club house/rwdclubhouse3.JPG"
                    alt="rwdclubhouse3"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">RWD Club House</span>
                  </div>
                </a>
              </div>

              <div className="jangoz-img-card">
                <a href="/project/surya-bhavan">
                  <img
                    src="/assets/surya bhavan/suryabhavan3.jpeg"
                    alt="surya-bhavan"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Surya Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/vip-residential">
                  <img
                    src="/assets/VIP residential/VIP residental2.jpeg"
                    alt="VIP Residential"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">VIP Residential</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card jangoz-last-centered">
                <a href="/project/dbs-workspace">
                  <img
                    src="/assets/DBS workspace/Dbs workspace8.jpeg"
                    alt="DBS Workspace"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">DBS Workspace</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Architecture */ }
        <div
          className="tab-pane fade"
          id="pills-proj4"
          role="tabpanel"
          aria-labelledby="pills-proj4-tab"
        >
          <div className="container mt-50 mb-50">
            <div className="jangoz-row jangoz-row-3">
              <div className="jangoz-img-card">
                <a href="/project/jangoz">
                  <img
                    src="/assets/jangoz/jangoz5.JPG"
                    alt="jangoz5"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Jangoz</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/manoj-bhavan">
                  <img
                    src="/assets/manoj bhavan/manojbhavan3.jpg"
                    alt="manojbhavan3"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Manoj Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/padmam">
                  <img
                    src="/assets/Padmam/HRP09683.jpg"
                    alt="padmam4"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Padmam</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/rwd-club-house">
                  <img
                    src="/assets/rwd club house/rwdclubhouse4.JPG"
                    alt="RWD Club House 4"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">RWD Club House</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/surya-bhavan">
                  <img
                    src="/assets/surya bhavan/suryabhavan4.jpeg"
                    alt="Surya Bhavan"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">Surya Bhavan</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card">
                <a href="/project/vip-residential">
                  <img
                    src="/assets/VIP residential/VIP residental4.jpeg"
                    alt="VIP Residential"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">VIP Residential</span>
                  </div>
                </a>
              </div>
              <div className="jangoz-img-card jangoz-last-centered">
                <a href="/project/dbs-workspace">
                  <img
                    src="/assets/DBS workspace/Dbs workspace4.jpeg"
                    alt="DBS Workspace"
                  />
                  <div className="jangoz-img-overlay">
                    <span className="jangoz-img-title">DBS Workspace</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
